export default "__VITE_ASSET__0db70f87__"